<template>
  <table :class="classes">
    <thead v-if="columns.length && !definitionTable">
      <slot name="table-header-row">
      </slot>
      <tr>
        <th v-for="column in columns" v-show="column.show"
            :width="column.width" :classes="column.classes">
          {{ titleCase(column.header) }}
        </th>
        <slot name="table-column">
        </slot>
      </tr>
    </thead>
    <tbody v-if="!definitionTable && useData">
      <div v-if="loading && !useData" class="ui active centered inline loader">
        <div class="ui text loader">{{ $t('loading') }}...</div>
      </div>
      <tr v-for="(row, index) in pageData(data, currentPage, paginationEnable ? dataPerPage : data.length)"
          :class="row.classes">
        <td v-for="column in columns" v-show="column.show" :class="column.classes">
          <div :class="{'long-text': useLongTextStyle}" v-if="!column.html">
            {{ getValue(row[column.fieldName]) }}
          </div>
          <div v-else class="long-text"
               style="-webkit-line-clamp: 2;"
               v-html="row[column.fieldName].value"
               @click="row[column.fieldName].functionality()"></div>
        </td>
        <slot name="table-row-after" :row="row" :index="index"></slot>
      </tr>
    </tbody>
    <tbody v-if="!definitionTable && !useData">
      <div v-if="loading" class="ui active inverted dimmer">
        <div class="ui text loader">{{ $t('loading') }}...</div>
      </div>
      <tr v-for="(row, index) in methodFormatter(apiData)">
        <td v-for="column in columns" v-show="column.show">
          <div class="long-text" v-if="!column.html">
            {{ getValue(row[column.fieldName]) }}
          </div>
          <div v-else class="long-text"
               style="-webkit-line-clamp: 2;"
               v-html="row[column.fieldName].value"
               @click="row[column.fieldName].functionality()"></div>
        </td>
        <slot name="table-row-after" :row="row" :index="index"></slot>
      </tr>
    </tbody>
    <tbody v-if="definitionTable && useData">
      <div v-if="loading && !useData" class="ui active centered inline loader">
        <div class="ui text loader">{{ $t('loading') }}...</div>
      </div>
      <tr v-for="(value, key) in data" :key="key">
        <td :width="definitionTableWidth" v-if="!keyIsDate">{{ titleCase(key) }}</td>
        <td :width="definitionTableWidth" v-if="keyIsDate">{{ key }}</td>
        <td v-if="value !== null && value !== undefined && !value.html">
          {{ value }}
        </td>
        <td v-if="value !== null && value !== undefined && value.html"
            v-html="value.value"
            @click="value.functionality()">
        </td>
        <td v-if="value === null || value === undefined ">{{ '-' }}</td>
      </tr>
    </tbody>
    <tfoot v-if="!definitionTable" class="no-print">
      <tr v-if="paginationEnable || hasFooter">
        <slot name="footer" v-if="hasFooter"></slot>
        <th :colspan="columns.length  + 1 + addtionalColumnsNumber" class="right aligned"
            style="border-left: 0px !important;"
            v-if="paginationEnable">
          <paginate :numberOfPages="useData ? Math.ceil(data.length / dataPerPage) : numberOfPages"
                    @paginationAbstractTable="paginationEventListenner"
                    :menuSizeClass="'small'"
                    :paginatorId="'AbstractTable'"
                    :firstPageButtonText="paginationFirstPageButtonText"
                    :lastPageButtonText="paginationLastPageButtonText"
                    :prevButtonText="paginationPervButtonText"
                    :nextButtonText="paginationNextButtonText">
          </paginate>
        </th>
      </tr>
      <slot name="footerRow" v-if="hasFooter"/>
    </tfoot>
  </table>
</template>

<script>
export default {
  components: {
    paginate: require('@/components/abstract_components/PaginationComponent').default
  },
  props: {
    classes: { type: String, default: 'ui table' },
    columns: { type: Array, default: () => { return [] } },
    useData: { type: Boolean, default: true },
    data: { required: this.useData },
    definitionTable: { type: Boolean, default: false },
    definitionTableWidth: { type: String, default: '20%' },
    lineNumbers: { type: Boolean, default: false },
    dataPerPage: { type: Number, default: 10 },
    paginationEnable: { type: Boolean, default: false },
    paginationNextButtonText: { type: String, default: 'Next' },
    paginationPervButtonText: { type: String, default: 'Previous' },
    addtionalColumnsNumber: { type: Number, default: 0 },
    paginationFirstPageButtonText: { type: String, default: 'First' },
    paginationLastPageButtonText: { type: String, default: 'Last' },
    indexRoute: { type: String, default: '' },
    methodFormatter: { type: Function, default: () => { return null } },
    hasFooter: { type: Boolean, default: false },
    filters: { type: String, default: '' },
    startSearchingFlag: { type: Boolean, default: false },
    apiObjectName: { type: String, required: this.useData },
    useLongTextStyle: {type: Boolean, default: true},
    keyIsDate: { type: Boolean, default: false }
  },
  data () {
    return {
      currentPage: 1,
      apiData: [],
      loading: true,
      numberOfPages: 1
    }
  },
  watch: {
    startSearchingFlag: function () {
      if (this.startSearchingFlag) {
        this.loading = true
        this.$http.get(`${this.indexRoute}?page=${this.currentPage}&items=${this.dataPerPage}${this.filters}`, {
          params: {
            clinic_id: this.getFromLocalStorage('clinicId')
          }
        }).then(response => {
          this.apiData = response.data[this.apiObjectName]
          this.numberOfPages = response.data.meta.pages
          this.loading = false
          this.$emit('endSearchingProcess')
        }).catch(() => {
          this.apiData = []
          this.numberOfPages = 1
          this.loading = false
          this.$emit('endSearchingProcess')
        })
      }
    }
  },
  mounted () {
    if (!this.useData) {
      this.currentPage = 1
      this.$http.get(`${this.indexRoute}?page=${this.currentPage}&items=${this.dataPerPage}${this.filters}`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      }).then(response => {
        this.apiData = response.data[this.apiObjectName]
        this.numberOfPages = response.data.meta.pages
        this.loading = false
        this.emitValues()
      })
    }
  },
  methods: {
    paginationEventListenner (event) {
      this.currentPage = event.pageNumber
      this.loading = true
      this.$http.get(`${this.indexRoute}?page=${this.currentPage}&items=${this.dataPerPage}${this.filters}`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      }).then(response => {
          this.apiData = response.data[this.apiObjectName]
          this.numberOfPages = response.data.meta.pages
          this.loading = false
          this.emitValues()
        })
    },
    getValue (columnValue) {
      let value = columnValue ? (columnValue.filteredValue || columnValue) : '-'
      return value
    },
    emitValues () {
      this.$emit('table-data', {
        data: this.apiData
      })
    }
  }
}
</script>

<style scoped>
  /*.long-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/abstract_components/AbstractTable.vue